import { useEffect, useState } from "react";
import Loader from "../../common/Loader";
import { inProduction } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Button from "../../common/Button";
import { MdClose } from "react-icons/md";
import { LiaSearchPlusSolid } from "react-icons/lia";
import Pagination from "../../common/Pagination";
import InputField from "../../common/InputField";
import { TiMinus, TiPlus } from "react-icons/ti";
import { AiOutlineCheck } from "react-icons/ai";
import { IoIosSave } from "react-icons/io";
import Table from "../../common/Table";

const InProduction = () => {
  const [inProductionData, setInProductionData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isCastingData, setIsCastingData] = useState([]);
  const [isMarkDoneData, setIsMarkDoneData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const pageSize = 10;
  const [activeTab, setActiveTab] = useState("in-ProductionData");

  const fetchMarkDoneData = async () => {
    try {
      const res = await inProduction.getAllInMarkDone(currentPage, pageSize);
      setIsMarkDoneData(res.data || []);
      setTotalRecords(res.totalCount || res.data?.length || 0);
    } catch (error) {
      notify("Error fetching Casting data", "error");
    }
  };

  const fetchCastingData = async () => {
    try {
      const res = await inProduction.getAllCastingNo();
      setIsCastingData(
        res.map((cas) => ({
          value: cas.casting_No,
          label: cas.casting_No,
        }))
      );
    } catch (error) {
      notify("Error fetching Casting data", "error");
    }
  };

  const fetchInProductionData = async () => {
    setLoading(true);
    try {
      const res = await inProduction.getAllInProduction(currentPage, pageSize);
      setInProductionData(res.data || []);
      setFilteredData(res.data || []);
      setTotalRecords(res.totalCount || res.data?.length || 0);
    } catch (error) {
      notify("Error fetching Order Plan data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchInProductionData();
    fetchCastingData();
  }, [currentPage]);

  useEffect(() => {
    if (activeTab === "finish") {
      fetchMarkDoneData();
    }
  }, [activeTab, currentPage]);

  const handleRowChange = (index, field, value) => {
    const updated = [...filteredData];
    const row = updated[index];

    row[field] = value;
    if (row.isCloned) {
      row.isCloned = false;
    }
    const billetSize = parseFloat(row.billet_Size) || 0;
    const noOfBillet = parseFloat(row.no_Of_Billet) || 0;
    const outWt = parseFloat(row.output_Weight) || 0;
    const inputWt = 0.0386 * billetSize * noOfBillet;
    if (!isNaN(inputWt)) {
      row.input_Weight = parseFloat(inputWt.toFixed(2));
    }
    if (row.input_Weight > 0 && outWt > 0) {
      const recovery = (outWt / row.input_Weight) * 100;
      row.recovry = parseFloat(recovery.toFixed(2));
    }
    setFilteredData(updated);
  };

  const handleSave = async (row, index) => {
    console.log(row, "row");

    const payload = {
      seq_No: row.seq_No,
      die_Id: row.die_Id,
      order_No: row.order_No,
      order_Qty_Pcs: parseInt(row.qty_Pcs) || 0,
      order_Qty_Weight: parseFloat(row.qty_Weight) || 0,
      casting_No: row.casting_No?.value || row.casting_No,
      Cut_Length: parseFloat(row.cut_Length) || 0,
      pcs_Needed: parseFloat(row.pcs_Needed) || 0,
      stertching_Rejection_Ft: parseFloat(row.stertching_Rejection_Ft) || 0,
      but_End_Rejection_Mm: parseFloat(row.but_End_Rejection_Mm) || 0,
      die_In_Time: row.die_In,
      die_Out_Time: row.die_Out,
      act_Output_WT: parseFloat(row.output_Weight) || 0,
      act_Input_WT: parseFloat(row.input_Weight) || 0,
      rec_Billet_Length: parseFloat(row.billet_Size) || 0,
      rec_Billet_PCS: parseInt(row.no_Of_Billet) || 0,
      act_production_Qty: parseInt(row.no_Of_Pcs) || 0,
      act_Yield_Per: parseFloat(row.recovry) || 0,
      extrusion_Speed: parseFloat(row.ext_Speed) || 0,
      billetTemp: parseFloat(row.billet_Temp) || 0,
      extrusion_Pressure: parseFloat(row.extrusion_Pressure) || 0,
      remark: row.remark || "",
      created_By: 1,
    };

    try {
      await inProduction.saveOrUpdate(payload);
      notify(`Row ${index + 1} saved successfully!`, "success");
      fetchInProductionData();
    } catch (error) {
      notify(`Failed to save Row ${index + 1}`, "error");
    }
  };

  const handleDelete = async (index) => {
    const row = filteredData[index];
    if (row.seq_No === 0) {
      const updated = [...filteredData];
      updated.splice(index, 1);
      setFilteredData(updated);
      notify(`Row ${index + 1} removed`, "info");
      return;
    }
    try {
      await inProduction.delete(row.seq_No);
      notify(`Row ${index + 1} deleted successfully!`, "success");
      fetchInProductionData();
    } catch (error) {
      notify(`Failed to delete Row ${index + 1}`, "error");
    }
  };

  const handleAdd = (insertIndex) => {
    const currentRow = filteredData[insertIndex];

    const newRow = {
      ...currentRow,
      seq_No: 0,
      isCloned: true,
    };

    const updatedRows = [...filteredData];
    updatedRows.splice(insertIndex + 1, 0, newRow);
    setFilteredData(updatedRows);
  };

  const handleMarkDone = async (index) => {
    const row = filteredData[index];
    const payload = {
      seq_No: row.seq_No,
      order_No: row.order_No,
      die_Id: row.die_Id,
      casting_No: row.casting_No?.value || row.casting_No,
      Cut_Length: parseFloat(row.cut_Length) || 0,
      pcs_Needed: parseFloat(row.pcs_Needed) || 0,
      stertching_Rejection_Ft: parseFloat(row.stertching_Rejection_Ft) || 0,
      but_End_Rejection_Mm: parseFloat(row.but_End_Rejection_Mm) || 0,
      die_In_Time: row.die_In,
      die_Out_Time: row.die_Out,
      act_Output_WT: parseFloat(row.output_Weight) || 0,
      act_Input_WT: parseFloat(row.input_Weight) || 0,
      rec_Billet_Length: parseFloat(row.billet_Size) || 0,
      rec_Billet_PCS: parseInt(row.no_Of_Billet) || 0,
      act_production_Qty: parseInt(row.no_Of_Pcs) || 0,
      act_Yield_Per: parseFloat(row.recovry) || 0,
      extrusion_Speed: parseFloat(row.ext_Speed) || 0,
      billetTemp: parseFloat(row.billet_Temp) || 0,
      extrusion_Pressure: parseFloat(row.extrusion_Pressure) || 0,
      remark: row.remark || "",
      created_By: 1,
    };

    try {
      await inProduction.saveOrUpdate(payload);
      notify(
        `Row ${index + 1} saved successfully before marking done!`,
        "success"
      );
      await inProduction.MarkProductionDone({
        batch_Id: row.batch_Id,
        seq_No: row.seq_No || 0,
        created_By: 1,
      });

      notify(`Row ${index + 1} marked as done!`, "success");
      fetchInProductionData();
    } catch (error) {
      notify(`Failed to save or mark row ${index + 1} as done`, "error");
      console.error(error);
    }
  };

  const outputWtTotal = isMarkDoneData.reduce(
    (sum, row) => sum + (parseFloat(row.output_Weight) || 0),
    0
  );

  const pcsTotal = isMarkDoneData.reduce(
    (sum, row) => sum + (parseFloat(row.no_Of_Pcs) || 0),
    0
  );

  const n = (v) => {
    const x = parseFloat(v);
    return Number.isFinite(x) ? x : 0;
  };

  const safeDiv = (a, b) => {
    const A = n(a),
      B = n(b);
    return B > 0 ? A / B : null;
  };

  const calcFinal = (r) => {
    const currentDiePer12 = n(r.current_Die_Weight);
    const cutLenFt = n(r.cut_Length);
    const pcsNeeded = n(r.pcs_Needed);
    const butEndMm = n(r.but_End_Rejection_Mm);
    const stretchFt = n(r.stertching_Rejection_Ft);
    const cutLenMM = cutLenFt * 304.8;
    const secondCal = (currentDiePer12 / 3660) * cutLenMM;

    const suggBilletlength =
      secondCal * pcsNeeded +
      butEndMm * 0.0386 +
      (currentDiePer12 / 3660) * stretchFt * 304;

    const final = suggBilletlength / 0.0386;
    return Number.isFinite(final) ? final : null;
  };

  return (
    <>
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5 mt-10 ">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="relative w-full sm:w-1/2 lg:w-1/3">
            <input
              type="text"
              className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              icon={LiaSearchPlusSolid}
              iconSize="w-5 h-5"
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary"
            ></Button>
            {searchQuery && (
              <Button
                icon={MdClose}
                onClick={() => setSearchQuery("")}
                iconSize="w-5 h-5"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
              ></Button>
            )}
          </div>
        </div>
        <div className="flex gap-4 mb-4">
          <Button
            text="In-Production Data"
            onClick={() => setActiveTab("in-ProductionData")}
            className={`rounded p-2
              ${
                activeTab === "in-ProductionData"
                  ? "bg-primary text-white"
                  : "bg-gray-200"
              }
            `}
          />
          <Button
            text="Finish Data"
            onClick={() => setActiveTab("finish")}
            className={` rounded p-2
              ${
                activeTab === "finish" ? "bg-primary text-white" : "bg-gray-200"
              }
            `}
          />
        </div>

        {loading ? (
          <Loader />
        ) : activeTab === "in-ProductionData" ? (
          <div className="overflow-x-auto py-4">
            <div className="space-y-6">
              {filteredData.map((row, i) => (
                <div
                  key={i}
                  className="bg-white shadow-md border rounded-xl p-5 w-full"
                >
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-2 ">
                      <InputField
                        label="Batch Id"
                        value={row.batch_Id}
                        disabled
                      />
                    </div>
                    <div className="">
                      <InputField label="So No" value={row.order_No} disabled />
                    </div>
                    <div className="">
                      <InputField
                        label="Order Pcs"
                        value={row.qty_Pcs}
                        disabled
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Order Pcs Wt"
                        value={row.qty_Weight}
                        disabled
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Die No"
                        value={row.dieNumber}
                        disabled
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Profile Name"
                        value={row.profile_Name}
                        disabled
                      />
                    </div>
                    <div className="col-span-2  md:col-span-2">
                      <InputField
                        label="Casting No"
                        type="select"
                        options={isCastingData}
                        value={row.casting_No}
                        onChange={(val) =>
                          handleRowChange(i, "casting_No", val)
                        }
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Die In"
                        type="time"
                        value={row.die_In}
                        onChange={(e) => handleRowChange(i, "die_In", e)}
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Die Out"
                        type="time"
                        value={row.die_Out}
                        onChange={(e) => handleRowChange(i, "die_Out", e)}
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Cut Length"
                        value={row.cut_Length}
                        disabled
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Current Weight"
                        value={row.current_Die_Weight}
                        disabled
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Pcs Needed"
                        value={row.pcs_Needed}
                        onChange={(e) => handleRowChange(i, "pcs_Needed", e)}
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Billet Size"
                        value={row.billet_Size}
                        onChange={(e) => handleRowChange(i, "billet_Size", e)}
                      />
                      {(() => {
                        const v = calcFinal(row);
                        return v !== null ? (
                          <p className="mt-1 text-xs text-slate-500">
                            Size: {v.toFixed(2)}
                          </p>
                        ) : null;
                      })()}
                    </div>
                    <div className="">
                      <InputField
                        label="No Of Billets"
                        value={row.no_Of_Billet}
                        onChange={(e) => handleRowChange(i, "no_Of_Billet", e)}
                      />
                      {(() => {
                        const ratio = safeDiv(row.qty_Pcs, row.pcs_Needed);
                        return ratio !== null ? (
                          <p className="mt-1 text-xs text-slate-500">
                            Billet pcs: {ratio.toFixed(2)}
                          </p>
                        ) : null;
                      })()}
                    </div>
                    <div className="">
                      <InputField
                        label="Input Wt (Kg)"
                        value={row.input_Weight}
                        disabled
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="No Of Pcs"
                        value={row.no_Of_Pcs}
                        onChange={(e) => handleRowChange(i, "no_Of_Pcs", e)}
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Out Wt"
                        value={row.output_Weight}
                        onChange={(e) => handleRowChange(i, "output_Weight", e)}
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Recov (%)"
                        value={row.recovry}
                        disabled
                      />
                    </div>
                    <div className="col-span-2 md:col-span-2">
                      <InputField
                        label="But End Rejection (mm)"
                        value={row.but_End_Rejection_Mm}
                        onChange={(e) =>
                          handleRowChange(i, "but_End_Rejection_Mm", e)
                        }
                      />
                    </div>
                    <div className="col-span-2 md:col-span-2">
                      <InputField
                        label="Stretching Rejection (Ft)"
                        value={row.stertching_Rejection_Ft}
                        onChange={(e) =>
                          handleRowChange(i, "stertching_Rejection_Ft", e)
                        }
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Ext Spd"
                        value={row.ext_Speed}
                        onChange={(e) => handleRowChange(i, "ext_Speed", e)}
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Billet Temp"
                        value={row.billet_Temp}
                        onChange={(e) => handleRowChange(i, "billet_Temp", e)}
                      />
                    </div>
                    <div className="">
                      <InputField
                        label="Ext Pressure"
                        value={row.extrusion_Pressure}
                        onChange={(e) =>
                          handleRowChange(i, "extrusion_Pressure", e)
                        }
                      />
                    </div>
                    <div className="col-span-7">
                      <InputField
                        label="Remarks"
                        value={row.remark}
                        onChange={(e) => handleRowChange(i, "remark", e)}
                      />
                    </div>
                    <div className=" flex items-center gap-4 ">
                      <Button
                        icon={TiMinus}
                        iconColor="text-red-500"
                        iconSize="w-7 h-7"
                        onClick={() => handleDelete(i)}
                      />
                      <Button
                        icon={TiPlus}
                        iconColor="text-blue-500"
                        iconSize="w-7 h-7"
                        onClick={() => handleAdd(i)}
                      />
                      <Button
                        icon={IoIosSave}
                        iconColor="text-green-600"
                        iconSize="w-7 h-7"
                        type="submit"
                        onClick={() => handleSave(row, i)}
                      />
                      <Button
                        type="button"
                        icon={AiOutlineCheck}
                        iconColor="text-yellow-600"
                        iconSize="w-7 h-7"
                        onClick={() => handleMarkDone(i)}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            <Table
              columns={[
                { key: "seq_No", label: "Seq No" },
                { key: "Order_No", label: "Order No" },
                { key: "batch_Id", label: "Batch ID" },
                { key: "dieNumber", label: "Die No" },
                { key: "casting_No", label: "Casting No" },
                { key: "qty_Pcs", label: "Order Qty Pcs" },
                { key: "qty_Weight", label: "Order Qty Wt" },
                { key: "cut_Length", label: "Cut Length" },
                { key: "die_In", label: "Die In" },
                { key: "die_Out", label: "Die Outo" },
                { key: "input_Weight", label: "Input Wt" },
                { key: "output_Weight", label: "Output Wt" },
                { key: "billet_Size", label: "Billet Size" },
                { key: "no_Of_Billet", label: "No. of Billets" },
                { key: "no_Of_Pcs", label: "No. of Pcs" },
                { key: "recovry", label: "Recovery %" },
                { key: "ext_Speed", label: "Ext. Speed" },
                { key: "billet_Temp", label: "Billet Temp" },
                { key: "extrusion_Pressure", label: "Extrusion Pressure" },
                { key: "current_Die_Weight", label: "Current Die Weight" },
                { key: "remark", label: "Remark" },
              ]}
              data={isMarkDoneData}
              showActions={false}
            />
            <div className="mt-4 px-4 py-3 bg-gray-100 rounded-md flex flex-wrap gap-4 text-sm font-medium">
              <div>
                Total Output Weight:{" "}
                <span className="text-primary">
                  {outputWtTotal.toFixed(2)} kg
                </span>
              </div>
              <div>
                Total No. of Pcs:{" "}
                <span className="text-primary">{pcsTotal}</span>
              </div>
            </div>
          </>
        )}

        <div className="flex justify-center items-center mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalRecords / pageSize)}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </>
  );
};

export default InProduction;
